import tick from "../icons/verified_purple.svg";

const VerifiedUserIcon = () => {
  return (
    <img
      className="verifiedTick"
      style={{
        width: "16px",
        height: "16px",
        marginLeft: "4px",
      }} src={tick} alt="verified user"
      title="Verified creator"
    />
  );
};

export default VerifiedUserIcon;
